import { commentsData } from '@/mocks/home';

const commentAvatars = [
  'https://readdy.ai/api/search-image?query=Chinese%20male%20avatar%20portrait%20casual%20style%20warm%20background%20simple%20minimal%20professional&width=80&height=80&seq=avatar-1&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20avatar%20portrait%20modern%20style%20clean%20warm%20background%20minimal&width=80&height=80&seq=avatar-2&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Chinese%20female%20student%20avatar%20portrait%20friendly%20warm%20background%20simple%20clean&width=80&height=80&seq=avatar-3&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%20avatar%20trendy%20style%20warm%20simple%20background%20minimal&width=80&height=80&seq=avatar-4&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Chinese%20male%20avatar%20portrait%20mature%20professional%20warm%20background%20simple%20minimal&width=80&height=80&seq=avatar-5&orientation=squarish',
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-10 text-center font-heading">社区热评</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-6xl mx-auto">
          {commentsData.map((comment, i) => (
            <div key={i} className="bg-background-50 rounded-lg p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={commentAvatars[i]}
                    alt={comment.author}
                    loading="lazy"
                    className="w-full h-full object-cover"
                    onError={(e: React.SyntheticEvent<HTMLImageElement>) => { (e.target as HTMLElement).style.display = 'none'; }}
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900 whitespace-nowrap">{comment.author}</div>
                  <div className="text-xs text-foreground-400">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}